import { WarningOutlined } from '@ant-design/icons';
import { Tooltip, Typography } from 'antd';
import * as React from 'react';

import { IconBadge, IconBadgeContentColor } from 'components/ui/IconBadge';
import { Spacing } from 'components/ui/Spacing';
import { ErrorEntity } from 'entities/common/Error';

import s from './CellErrorsTooltip.module.scss';

type Props = {
  errors: ErrorEntity[];
};

const CellErrorsTooltip: React.FC<Props> = ({ errors }: Props) => {
  const [visible, setVisible] = React.useState(false);

  return (
    <Tooltip
      onOpenChange={setVisible}
      destroyTooltipOnHide
      trigger="click"
      placement="bottom"
      title={() => (
        <Spacing>
          {errors.map((error, index) => (
            <Spacing.Row key={index}>
              <Typography.Text className={s.text}>
                <WarningOutlined />
              </Typography.Text>
              <Typography.Text className={s.text}>
                {error.message}
              </Typography.Text>
            </Spacing.Row>
          ))}
        </Spacing>
      )}
    >
      <IconBadge
        className={s.badge}
        isActive={visible}
        color={IconBadgeContentColor.error}
        IconComponent={WarningOutlined}
        count={errors.length}
      />
    </Tooltip>
  );
};

export default CellErrorsTooltip;
